import { render, staticRenderFns } from "./BETTER.vue?vue&type=template&id=20bb35ce&"
import script from "./BETTER.vue?vue&type=script&lang=js&"
export * from "./BETTER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports